import { fNumber } from 'common/utils/formatNumber'
import React, { ReactNode } from 'react'
import { ControllerRenderProps } from 'react-hook-form'

import TextField from '@mui/material/TextField'
import { formatWithCommasPreserveDecimals } from 'utils/formatNumber'

const DecimalTextField = ({
  field,
  error,
  helperText,
  endAdornment,
  disabled,
}: {
  field: ControllerRenderProps<any, any>
  error: boolean
  helperText?: ReactNode
  endAdornment?: ReactNode
  disabled?: boolean
}) => {

  return (
    <TextField
      {...field}
      fullWidth
      size="small"
      type="text"
      value={formatWithCommasPreserveDecimals(field.value)}
      onChange={(e) => {
        field.onChange(e.target.value)
      }}
      error={error}
      helperText={helperText}
      InputProps={{ endAdornment }}
      disabled={disabled}
    />
  )
}

export default DecimalTextField
